import { useNavigate } from "react-router-dom";

import { Button } from "atoms/button/Button";

import { QuizStepProps } from "../useQuestionnaire";

import { TextAreaStep } from "./components/TextAreaStep";

export const Pharmacy = (props: QuizStepProps) => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate("/health/glp/confirmation");
  };

  return (
    <div className="flex h-full flex-col gap-3">
      <TextAreaStep
        title="Please list the name and address of your current pharmacy."
        label="Pharmacy Name and Address"
        name="Pharmacy"
        onChange={(key, value) => props.handleStepData(key, value)}
        value={props.data.Pharmacy as string}
      />
      <div className="mt-auto">
        <Button fullWidth onClick={handleNext}>
          Next
        </Button>
      </div>
    </div>
  );
};
